import { EnumBadge } from "@/components/EnumBadge.tsx";
import { statusDescriptions } from "@/modules/compute/statusLabels.tsx";
import type { VirtualMachineLoc } from "@/modules/compute/vmQuery.ts";
import type { ManagedServiceLoc } from "@/modules/services/servicesQuery.ts";

export function ResourceStatusBadge({ item: { status } }: { item: VirtualMachineLoc | ManagedServiceLoc }) {
    return <EnumBadge options={statusDescriptions} value={status} />;
}
